import React from "react";

import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

const LoaderWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
`;

const SimulatorLoader = () => {
  return (
    <LoaderWrapper>
        <CircularProgress />
    </LoaderWrapper>
  )
}

export default SimulatorLoader
